module.exports = __webpack_public_path__ + "img/listening-feedback-dark.65700592.svg";